import {
  DirectoryMutation,
  DirectoryMutationResetUserAuthenticatorRegistrationArgs,
} from "@/graphql/types";
import { useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";

const resetUserAuthenticatorRegistrationDocument = gql`
  mutation resetUserAuthenticatorRegistration($userId: ID!) {
    resetUserAuthenticatorRegistration(userId: $userId)
  }
`;

export default function () {
  const mutation = useMutation<
    Pick<DirectoryMutation, "resetUserAuthenticatorRegistration">,
    DirectoryMutationResetUserAuthenticatorRegistrationArgs
  >(resetUserAuthenticatorRegistrationDocument, { errorPolicy: "none" });

  function call(userId: string) {
    return mutation.mutate({ userId });
  }

  return { ...mutation, call };
}
